import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { FC } from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { LoadingSpinner } from "components/loader";
import { withVar } from "themes/helpers";

import { HelpTooltip } from "./HelpTooltip";

const StyledTitleLoadingSpinner = styled.div`
  margin-left: 8px;
`;

const titleStyles = css`
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
`;

const headerStyles = css`
  display: flex;
  align-items: center;
  min-height: 34px;
`;

interface IProps {
  title: string;
  loading: boolean;
  tooltip?: React.ReactNode;
  exportFileName?: string;
  exportData?: (string | number)[][];
  onDataExported?(): void;
}

export const ChartHeader: FC<IProps> = ({ title, loading, tooltip }) => (
  <div css={headerStyles}>
    <div css={titleStyles}>
      {title}
      {tooltip && <HelpTooltip chartTitle={title}>{tooltip}</HelpTooltip>}
      {loading && (
        <StyledTitleLoadingSpinner>
          <LoadingSpinner isVisible size="20px" />
        </StyledTitleLoadingSpinner>
      )}
    </div>
  </div>
);
